import React, { Fragment, useState } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
} from "reactstrap"
import { Link, useHistory } from "react-router-dom"
import Util from "./Common/Util"

import moment from 'moment';

import "chartist/dist/scss/chartist.scss";

import { useSelector } from 'react-redux';

import { getTreatmentDashBoardData } from 'crud/dashboard.crud';
import { useEffect } from 'react';
import Modal from "components/RopikCustom/Modal_v2";
import { disposeComplete, disposeListComplete, getTreatmentDisposeDashboardList } from "crud/auth.crud";

const selectedClass = 'secondary-bg white-text border-none'
const unselectedClass = 'button-border secondary-text white-bg'

const Treatment = props => {
  const newDate = new Date()
  const month = newDate.getMonth()

  const [dashboardItem, setDashboardItem] = useState([])
  const [dataList, setDataList] = useState([])
  const [selectedList, setSelectedList] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const [page, setPage] = useState(1)
  const [modalShow, setModalShow] = useState({
    batchProcessing: false,
    approval: false
  })
  const [selectedItem, setSelectedItem] = useState(null)
  const [inputItem, setInputItem] = useState(null)

  const changeInputCondition = (key, value) => {
    setInputItem(prev => ({...prev, [key]: value}))
  }

  const modalOpen = (key) => {
    setModalShow(prev => ({...prev, [key]: true}))
  }

  const modalClose = (key) => {
    setModalShow(prev => ({...prev, [key]: false}))
  }

  const getTopDashBoardData = async () => {
    try {
      const response = await getTreatmentDashBoardData();
      if (response.data?.result === 'success') {
        const item = response.data?.data
        const summaryList = [
          { text: '금일 총 입고량', value: Util.setCommaPrice(item.today_wearing_qty_sum / 1000), unit: 'ton' },
          { text: '금월 총 입고량', value: Util.setCommaPrice(item.month_wearing_qty_sum / 1000), unit: 'ton' },
          { text: '금월 미정산 금액', value: Util.setCommaPrice(item.report_month), unit: '원', box: item.report_month_count },
          { text: '전월 미정산 금액', value: Util.setCommaPrice(item.prev_report_month), unit: '원', box: item.prev_report_month_count },
          { text: '전일 총 입고량', value: Util.setCommaPrice(parseInt(item.yesterday_wearing_qty_sum / 1000)), unit: 'ton' },
          { text: '전월 총 인계량', value: Util.setCommaPrice(parseInt(item.prev_month_dispose_qty_sum)) / 1000, unit: 'ton' },
          { text: '총 거래처 수', value: Util.setCommaPrice(item.correspondent_count), unit: '' },
          { text: '입고 알림', value: Util.setCommaPrice(item.alarm_count), unit: '건' }
        ];
        setDashboardItem(summaryList)
      }
      setRefresh(false)
    } catch (error) {
      console.error(error);
      setRefresh(false)
    }
  }
  
  const getDataList = async () => {
    try {
      const response = await getTreatmentDisposeDashboardList()
      if (response?.data?.result === 'success') {
        setDataList(response?.data?.data || [])
      }
      setRefresh(false)
    } catch (error) {
      console.error(error);
      setRefresh(false)
    }
  }

  const changeDisposeState = async() => {
    if (isLoading)
      return

    setIsLoading(true)
    try {
      const params = {
        id : selectedItem?.id,
        memo: inputItem?.memo || '',
        qty: inputItem?.qty || selectedItem?.qty
      }
      const response = await disposeComplete(params)
      if (response?.data?.result === 'success') {
        modalClose('approval')
        setSelectedItem(null)
        setSelectedList([])
        setRefresh(true)
      } else {
        alert(response?.data?.msg)
      }
      setIsLoading(false)
    } catch (error) {
      console.error(error);
      setIsLoading(false)
    }

  }

  const batchProcess = async() => {
    if (isLoading)
      return
    if (selectedList.length === 0) {
      alert('입고승인할 항목을 1개 이상 선택해주세요.')
    }
    setIsLoading(true)
    try {
      const params = {
        ids : JSON.stringify(selectedList),
      }
      const response = await disposeListComplete(params)
      if (response?.data?.result === 'success') {
        modalClose('batchProcessing')
        setSelectedItem(null)
        setSelectedList([])
        setRefresh(true)
      } else {
        alert(response?.data?.msg)
      }
      setIsLoading(false)
    } catch (error) {
      console.error(error)
      setIsLoading(false)
    }
  }

  const checkList = (item) => {
    setSelectedList(prev => prev.includes(item.id) ? prev.filter(v => v !== item.id) : [...prev, item.id])
  }

  useEffect(() => {
    getTopDashBoardData()
    getDataList()
  }, [refresh])

  return (
    <Fragment>
      <Row>
        {dashboardItem.length > 0 && dashboardItem.map((item, index) => (
          <Col xs={12} md={6} lg={6} xl={3} key={'dashboard_item_' + index}>
            <Card style={{ height: 150 }} className='position-relative box-border'>
              {item.box > 0 &&
                <div className='unsettled-box error-bg white-text'>{item.box}</div>
              }
              <CardBody className='d-flex flex-direction-column'>
                <Row>
                  <Col>
                    <p className='font-size-18 primary-text font-weight-bold'>{item.text}</p>
                  </Col>
                </Row>
                <Row className='justify-content-end mt-auto'>
                  <p className='fit-content mb-0 font-size-50 font-weight-800'>{Util.setCommaPrice(item.value)}<span className='font-size-18'> {item.unit}</span></p>
                </Row>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>

      <Row>
        <Col xl={6} lg={12}>
          <div className='d-flex justify-content-between align-items-center margin-top-40 mb-2'>
            <p className='font-size-16 mb-0'>■ 입고 리스트<span className="font-size-12"> [ 건수 : 최대 100건 / 수거시간 최신 순 ]</span></p>
            <div className="waver-pagination-btn-group" >
              <button style={{width: 143}} className="custom-btn secondary-bg border-radius-0 white-text border-none margin-right-0"
              onClick={() => {
                modalOpen('batchProcessing')
              }} >
                입고일괄처리
              </button>
            </div>
          </div>

          <Card>
            <CardBody style={{ padding: 0, borderRadius: 4, overflow: 'hidden' }}>
              <div id={"sc-body"} style={{maxHeight: 660}} className="table-responsive">
                <table className="table table-hover table-centered table-nowrap mb-0 chart-table">
                  <thead className="chart-thead">
                    <tr>
                      <th scope="col">선택</th>
                      <th scope="col">운반업체 명</th>
                      <th scope="col">차량번호</th>
                      <th scope="col">인계일시</th>
                      <th scope="col">인계량(kg)</th>
                      <th scope="col">입고처리</th>
                    </tr>
                  </thead>
                  <tbody className="chart-tbody">
                    {dataList.map((item, index) => {
                      return (
                        <tr key={item.id + '_' + index}>
                          <td>
                            <input className={`is-untouched is-pristine av-valid form-check-input ${item.state === 'Y' ? 'dashboard-check-disabled' : 'dashboard-check-abled'}`} type="checkbox" name="charge_report" checked={selectedList.includes(item?.id)} disabled={item.state === 'Y'} onChange={() => {
                              checkList(item)
                            }} />
                          </td>
                          <td>{item.company?.name}</td>
                          <td>{item.car?.number}</td>
                          <td>{moment(item.created_at).format('YYYY-MM-DD HH:mm:ss')}</td>
                          <td>{Util.setCommaPrice(item.qty)}</td>
                          <td className="click-not">
                            <button style={{ width: 84, height: 29 }} type="button" className={`custom-btn border-radius-0 margin-right-4 font-size-15 line-height-1 ${item.state === 'Y' ? unselectedClass : selectedClass}`} onClick={(e) => {
                              e.stopPropagation()
                              if (item.state === 'I') {
                                modalOpen('approval')
                                setSelectedItem(item)
                              }
                            }}>
                              {item.state === 'Y' ? '입고완료' : '입고승인'}
                            </button>
                          </td>
                        </tr>
                      )
                    })}
                    {dataList.length === 0 &&
                      <tr>
                        <td scope="row" colSpan="14">데이터가 없습니다.</td>
                      </tr>
                    }

                  </tbody>
                </table>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Modal
        title={'인수 일괄 처리'}
        show={modalShow.batchProcessing}
        onHide={() => {
          modalClose('batchProcessing')
        }}
        size="md"
        bodyChildren={
          <Fragment>
            <p>인수 처리 되지 않은 인계 목록의 처리량이 일괄적으로 인수처리 됩니다.</p>
            <p>정말 인수 일괄 처리를 하시겠습니까?</p>
          </Fragment>
        }
        footerChildren={
        <div className="d-flex justify-content-end">
          <button style={{width: 'auto'}} type="button" className="waves-effect custom-btn active btn btn-dark-gradient btn-sm" onClick={() => {
            batchProcess()
          }}>
            확인
          </button>
          <button style={{width: 'auto'}} type="button" className="waves-effect custom-btn active btn btn-white-border btn-sm" onClick={() => {
            modalClose('batchProcessing')
          }}>
            취소
          </button>
        </div>
        }
      >
      </Modal>

      <Modal
        title={'인계량 확인'}
        show={modalShow.approval}
        onHide={() => {
          modalClose('approval')
          setSelectedItem(null)
        }}
        size="lg"
        bodyChildren={
          <Fragment>
            <table className="input-table">
              <tbody>
                <tr>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">사업자번호</td>
                  <td className="w-35">
                    {selectedItem?.company?.company_number}
                  </td>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">상호</td>
                  <td className="w-35">
                    {selectedItem?.company?.name}
                  </td>
                </tr>
                <tr>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">인계일시</td>
                  <td className="w-35">
                    {moment(selectedItem?.created_at).format('YYYY-MM-DD HH:mm:ss')}
                  </td>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">인계량</td>
                  <td className="w-35">
                    {/* {selectedItem?.qty} */}
                    <input className='waver-input-box w-100 border-radius-0' value={inputItem?.qty || selectedItem?.qty} placeholder="인계량을 입력해 주세요." onChange={(e) => {
                      changeInputCondition('qty', e.target.value)
                    }} />
                  </td>                  
                </tr>
                <tr>
                  <td className="w-15 padding-left-8 primary-bg white-text">메모</td>
                  <td colSpan="3" className="w-85 pb-0">
                    <textarea className="waver-text-box w-100 font-size-12 border-radius-0" value={inputItem?.memo}
                    onChange={(e)=>{
                      changeInputCondition('memo', e.target.value);
                    }} />
                  </td>
                </tr>
              </tbody>
            </table>
          </Fragment>
        }
        footerChildren={
        <div className="d-flex justify-content-end w-100">
          <div className="d-flex">
            <button style={{width: 59, height: 27}} className="`custom-btn border-radius-0 margin-right-4 font-size-11 line-height-1 secondary-bg white-text border-none" onClick={() => {
              changeDisposeState()
            }}>{'확인'}</button>
            <button style={{width: 59, height: 27}} className="custom-btn border-radius-0 font-size-11 line-height-1 button-border secondary-text white-bg margin-right-0" onClick={() => {
              setSelectedItem(null)
              modalClose('approval')
            }}>취소</button>
          </div>
        </div>
        }
      />
    </Fragment>
  )
}

export default Treatment